import { NotFound, PageRenderer, RenderProvider, SiteLayout, type PublicPageResponse, type RenderContextValue } from '@kfz/shared';

const emptyResources = { media: {}, sliders: {}, links: {}, maps: {} };

export function App({ data }: { data: PublicPageResponse }) {
  const value: RenderContextValue = {
    lang: data.language,
    page: data.page,
    site: data.site,
    menus: data.menus ?? {},
    resources: data.resources ?? emptyResources,
    mode: 'public',
    apiBase: '',
  };
  return (
    <RenderProvider value={value}>
      <SiteLayout>{data.kind === 'page' && data.page ? <PageRenderer content={data.page.content} /> : <NotFound />}</SiteLayout>
    </RenderProvider>
  );
}
